import { QuotesCourseApiDto } from '@lx/shared/api/models';

export const CourseClassificationEnum = QuotesCourseApiDto.CourseClassificationEnum;
